var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "chip-input" }, [
    _vm.disabled ? _c("div", { staticClass: "disable-overlay" }) : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "chip-input-main",
        class: _vm.chipInputClasses,
        on: { click: _vm.handleComponentClick }
      },
      [
        _vm.label
          ? _c(
              "label",
              {
                staticClass:
                  "mdc-floating-label mdc-floating-label--float-above"
              },
              [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "m-chip-set",
          { attrs: { input: true } },
          [
            _vm._l(_vm.chipset, function(chip) {
              return _c(
                "m-chip",
                { key: chip.name },
                [
                  chip.icon && !_vm.disabled
                    ? _c("m-icon", {
                        attrs: { slot: chip.icon.slot, icon: chip.icon.icon },
                        on: {
                          click: function($event) {
                            return _vm.onIconClick(chip)
                          }
                        },
                        slot: chip.icon.slot
                      })
                    : _vm._e(),
                  _vm._v("\n        " + _vm._s(chip.name) + "\n      ")
                ],
                1
              )
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.componentHasFocus,
                  expression: "componentHasFocus"
                }
              ],
              ref: "textInput",
              staticClass: "text-input",
              attrs: { type: "text" },
              on: {
                keyup: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.checkSubmit($event)
                },
                focus: function($event) {
                  _vm.componentHasFocus = true
                },
                blur: function($event) {
                  _vm.componentHasFocus = false
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "bottom-bar" })
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "helper-text" }, [
      _vm._v("\n    " + _vm._s(_vm.helperText) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }